import { TestId } from '@components/test-ids';
import styled from '@emotion/styled';
import { Testimonial } from '@model/iceberg/testimonial';
import { withTheme } from '@emotion/react';
import React from 'react';
import { Theme, ThemeProps } from '@theme/base';
import { Review } from '../review';
import { useElapsedTimer } from '@components/hooks';
import { ProgressBar } from './ProgressBar';
import { mq } from '@styles/breakpoints';

export interface CarouselProps {
  timeout: number;
  testimonials: Array<Testimonial>;
  theme: Theme;
}

const Container = styled.div(({ theme }: ThemeProps) => ({
  backgroundColor: theme.custom.colors.overlay.dark,
  backdropFilter: 'blur(10px)',
  borderRadius: theme.custom.spacing.small,
  margin: `${theme.custom.spacing.xxxLarge}px ${theme.custom.spacing.medium}px`,
  overflow: 'hidden',
  [mq.small]: {
    margin: 0
  }
}));

const getProgress = (elapsedTime: number, maxTime: number) => (elapsedTime / maxTime) * 100;

export const CarouselComponent = ({ timeout, testimonials }: CarouselProps) => {
  const { elapsedTime, index } = useElapsedTimer(timeout, testimonials.length);
  return (
    <Container data-testid={TestId.testimonial.carousel}>
      <Review testimonial={testimonials[index]} />
      <ProgressBar width={getProgress(elapsedTime, timeout)} />
    </Container>
  );
};

export const Carousel = withTheme(CarouselComponent);
